
import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t py-8 px-6 md:px-12">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <img 
              src="/lovable-uploads/790584d5-9b6b-43b4-9f50-678735f69ef5.png" 
              alt="Morgen Health Logo" 
              className="h-8 mb-2"
            />
            <p className="text-sm text-gray-600 mt-1">Empowering your health journey</p>
          </div>
          <div className="flex flex-col md:flex-row md:space-x-8 space-y-4 md:space-y-0">
            <div>
              <h3 className="font-satoshi font-medium mb-2">Company</h3>
              <ul className="space-y-1">
                <li><a href="#" className="text-sm text-gray-600 hover:text-morgenBlue transition-colors">About Us</a></li>
                <li><a href="#" className="text-sm text-gray-600 hover:text-morgenBlue transition-colors">Team</a></li>
                <li><a href="#" className="text-sm text-gray-600 hover:text-morgenBlue transition-colors">Careers</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-satoshi font-medium mb-2">Support</h3>
              <ul className="space-y-1">
                <li><a href="/contact" className="text-sm text-gray-600 hover:text-morgenBlue transition-colors">Contact</a></li>
                <li><a href="#" className="text-sm text-gray-600 hover:text-morgenBlue transition-colors">Privacy Policy</a></li>
                <li><a href="#" className="text-sm text-gray-600 hover:text-morgenBlue transition-colors">Terms of Service</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-6 border-t text-center md:text-left">
          <div className="flex flex-col md:flex-row md:justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-sm text-gray-600">&copy; {currentYear} Morgen Health Inc. All rights reserved.</p>
              <p className="text-sm text-gray-600">Website: <a href="https://www.morgenhealth.com" className="hover:text-morgenBlue transition-colors">www.morgenhealth.com</a></p>
            </div>
            <div className="text-sm text-gray-600">
              <p>3343 Peachtree Rd NE, Suite 145 #2956, Atlanta, GA 30326</p>
              <p><a href="mailto:info@morgenhealth.com" className="hover:text-morgenBlue transition-colors">info@morgenhealth.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
